import React, { useEffect, useState } from "react";
import MultiRangeSlider from "./MultirangeSlider";
import { useFormik } from "formik";
import { Form } from "react-bootstrap";
import { httpReauest } from "../../utils/httpRequest";
import { CDN_BASE_URL } from "../../config";
import { Link, useSearchParams } from "react-router-dom";
import Loading from "./Loading";

const FilterCategory = ({ formik, dealerData, handleSubmit, name }) => {
  const [categories, setCategories] = useState();
  const [loading, setloading] = useState(true);

  const {
    category,
    brand,
  } = formik.values;

  useEffect(() => {
    handleSubmit();
    getData();
  }, [formik.values]);

  useEffect(() => {}, []);

  async function getData(params) {
    if (category) {
      await httpReauest("GET", "/category/header", {}, {}).then(({ data }) => {
        const newCategory = data.data.brands.filter(
          (item) => item.category == category
        );
        setCategories(newCategory);
        setloading(false);
      });
    }
  }
  return (
    <div className="w-full flex flex-col gap-4 sticky top-[110px]  ">
      <h2 className="text-[20px] font-bold flex justify-between items-end ">
        برند ها در {name}
      </h2>
      <div className="grid grid-cols-2 gap-3 overflow-y-scroll max-h-[75vh] pe-2">
        {loading ? (
          <Loading />
        ) : (
          categories?.map((cat) => (
            <span
              key={cat.brand._id}
              onClick={() =>
                cat.brand._id === formik.values.brand
                  ? formik.setFieldValue("brand", "")
                  : formik.setFieldValue("brand", cat.brand._id)
              }
              className={`${
                formik.values.brand === cat.brand._id ? "bg-black " : "border-brand"
              } py-3 flex flex-col items-center justify-center  cursor-pointer rounded-[10px]`}
            >
              <img
                src={CDN_BASE_URL + cat.brand.logo}
                alt={cat.brand.name}
                title={cat.brand.name}
                className="w-[40%]"
              />
              <p
                className={`${
                  formik.values.brand === cat.brand._id ? "text-secendory" : ""
                } text-[16px] font-[500] text-center mt-2 mb-0`}
              >
                {cat.brand.title}
              </p>
            </span>
          ))
        )}
      </div>
    </div>
  );
};

export default FilterCategory;
